import { MapException } from 'utils/mapUtils/MapException'

const getObjKey = (code, id) => `${code || ''}${id}`

export default class ILayers {
    constructor() {
        this.uuid = []
        // Index des features : les recherches par uuid / station sont faites à chaque survol, clic et filtre
        this.uuidIndex = new Map()
        this.objIndexes = undefined
        if (!this.getLayer) {
            throw new MapException('getLayer is not defined')
        }
    }

    generateUUID() {
        let d = new Date().getTime()
        let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            let r = (d + Math.random() * 16) % 16 | 0
            d = Math.floor(d / 16)
            return (() => {
                if (c === 'x') {
                    return r
                }
                return (r & 0x3 | 0x8)
            })().toString(16)
        })
        return uuid
    }

    getUuid() {
        return this.uuid
    }

    getUuidEntry(u) {
        return this.uuidIndex.get(u)
    }

    getObjIndexes() {
        if (!this.objIndexes) {
            const byId = new Map()
            const byKey = new Map()
            this.uuid.forEach(entry => {
                if (!byId.has(entry.obj.id)) {
                    byId.set(entry.obj.id, entry)
                }
                const key = getObjKey(entry.obj.code, entry.obj.id)
                if (!byKey.has(key)) {
                    byKey.set(key, entry)
                }
            })
            this.objIndexes = { byId, byKey }
        }
        return this.objIndexes
    }

    findUuidByObjId(id) {
        return this.getObjIndexes().byId.get(id)
    }

    findUuidByObjKey(code, id) {
        return this.getObjIndexes().byKey.get(getObjKey(code, id))
    }

    getPopup() {
        return ''
    }

    checkUuid(u) {
        return this.uuidIndex.has(u)
    }

    registerFeature(obj = {}) {
        const uuid = this.generateUUID()
        const entry = { uuid, obj }
        this.uuid.push(entry)
        this.uuidIndex.set(uuid, entry)
        this.objIndexes = undefined
        return uuid
    }
}
